import { Link } from 'react-router-dom';
import './footer.css';
import logo from '../../assets/abjoy-logo-no-text.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: Brand & About */}
        <div className="footer-col">
          <img src={logo} alt="Logo" className="footer-logo" />
          <p className="footer-about">
            Professional solutions in civil construction, sound hire, and software development. 
            Quality driven, client focused.
          </p>
        </div>

        {/* Column 2: Navigation */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
          </ul>
        </div>

        {/* Column 3: Services */}
        <div className="footer-col">
          <h3>Our Services</h3>
          <ul>
            <li><Link to="/construction">Construction</Link></li>
            <li><Link to="/sound-hire">Sound Hire</Link></li>
            <li><Link to="/software-development">Software development</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Abjoy Development Services. All rights reserved.</p>
        <div className="footer-line"></div>
      </div>
    </footer>
  );
}

export default Footer;